import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { GlobalFooter } from '@/patterns/global-footer/src/global-footer';
import JiraSoftwareNavV2 from '@/templates/software/jira/sections/nav-bar/software-jira-navbar';
import { checkFeatureFlagGate } from '@/utils/feature-flags/check-feature-flag';
import { featureFlags } from '@/utils/feature-flags/feature-flag-manifest';

import { AISection } from './sections-v2/ai';
import { CommunitySection } from './sections-v2/community';
import { LaunchSection } from './sections-v2/featured-info/launch';
import { PlanSection } from './sections-v2/featured-info/plan';
import { ReportSection } from './sections-v2/featured-info/report';
import { TrackSection } from './sections-v2/featured-info/track';
import { FinalCTASection } from './sections-v2/final-cta';
import { HeroSection } from './sections-v2/hero';
import { IntegrationsSection } from './sections-v2/integrations';
import { ManageSection } from './sections-v2/manage';
import { TabsSection } from './sections-v2/tabs';

const cardsCSS = css({
	[`&.gwp7999-jira-features-updates`]: {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		[`.featured-info-card`]: {
			boxShadow: token('elevation.shadow.overlay'),
			borderRadius: token('radius.small'),
		},
	},
});

export const JiraSoftwareFeaturesPageTemplate = () => {
	const showGwp7999JiraFeaturesUpdates = checkFeatureFlagGate(featureFlags.gwp7999JiraFeatures);

	return (
		<div>
			<JiraSoftwareNavV2 />
			<main
				id="content"
				className={showGwp7999JiraFeaturesUpdates ? 'gwp7999-jira-features-updates' : ''}
				css={cardsCSS}
			>
				<HeroSection />
				<TabsSection />
				<PlanSection />
				<TrackSection />
				<LaunchSection />
				<ReportSection />
				<AISection />
				<ManageSection />
				<IntegrationsSection />
				<CommunitySection />
				<FinalCTASection />
			</main>
			<GlobalFooter />
		</div>
	);
};
